._CommunitiesView_j897g_1 {
  /* Empty file & class, used as a placeholder for future styling */
}